import "./footer.css";

import { FaFacebookF, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        OLAMIDE
      </a>

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>

        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Stacks</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a href="https://web.facebook.com/LDRE01" target="_blank">
          <FaFacebookF />
        </a>
        <a
          href="https://www.linkedin.com/in/olamide-abe-94b8311a4"
          target="_blank"
        >
          <FaLinkedin />
        </a>
        <a href="https://twitter.com/@holamiderefined" target="_blank">
          <FaTwitter />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; OLAMIDE'S PORTFOLIO. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
